import NotificationManager from "../../utils/class/notifications";

export default class JobsAdminPanel {
    constructor () {
        this.NotificationManager = new NotificationManager();

        const controls = {
            'publish': document.querySelector('#admin-publish'),
            'close': document.querySelector('#admin-close')
        };

        if (Object.values(controls).some((control) => !control)) return;

        this.publish = controls.publish;
        this.close = controls.close;

        this.init();
    }

    init () {
        this.publish.addEventListener('click', this.handlePublish.bind(this));
        this.close.addEventListener('click', this.handleClose.bind(this));
    }

    async handlePublish () {
        this.publish.classList.add('preload');

        try {
            await fetch('/wp-json/jobs/v1/admin-publish', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ action: 'publish_job' })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.NotificationManager.sendNotification('success', 'The job has been published!', data.message);

                    setTimeout(() => window.location.reload(), 3000);

                    this.publish.classList.remove('preload');
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', 'Your donation hasn\'t been received. Please, contact support.');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again.');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again.');
        }
    }

    async handleClose () {
        this.close.classList.add('preload');

        try {
            await fetch('/wp-json/jobs/v1/admin-close', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ action: 'close_job' })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.NotificationManager.sendNotification('success', 'The job has been closed!', data.message);

                    setTimeout(() => window.location.reload(), 3000);

                    this.close.classList.remove('preload');
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again.');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again.');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again.');
        }
    }
}